module.exports = __webpack_public_path__ + "assets/images_base/go-next-arrow.svg?v=7e6f9a6e";